import { connect } from 'react-redux';
import { default as MarketDashboardRoot } from './MarketDashboard';
import {
  getUserInfo,
  getTailoredRegionMarkers,
  setCurrency,
  getGoogleAutocompleteSessionToken,
  clearGoogleAutocompleteSessionToken,
  getCachedSearchMarkets,
  getTop10MarketCountryWise
} from 'src/store/Dashboard/actions';
import { registerThunk, getTokenThunk } from 'src/store/Auth/actions';

const mapStateToProps = ({ dashboard }) => ({
  tailoredRegionMarkers: dashboard.tailoredRegionMarkers,
  search: dashboard.search,
  user: dashboard.user,
  isUserAllowed: dashboard.isUserAllowed,
  currency: dashboard.currency,
  googleAutocompleteSessionToken: dashboard.googleAutocompleteSessionToken,
  googleAutocompleteSessionTokenTimeStamp: dashboard.googleAutocompleteSessionTokenTimeStamp,
  cachedSearchMarkets: dashboard.cachedSearchMarkets,
  cachedTop10MarketCountryWise: dashboard.cachedTop10MarketCountryWise,
});

export const MarketDashboard = connect(mapStateToProps, {
  getTokenThunk,
  getUserInfo,
  getTailoredRegionMarkers,
  setCurrency,
  getGoogleAutocompleteSessionToken,
  clearGoogleAutocompleteSessionToken,
  getCachedSearchMarkets,
  getTop10MarketCountryWise
})(MarketDashboardRoot);
